const frameActions = {
  FRAME_REQUEST_CANCELLED: 'FRAME_REQUEST_CANCELLED',
  FRAME_REQUEST_CREATED: 'FRAME_REQUEST_CREATED',
  FRAME_REQUEST_WORKFLOW_INITIALIZED_SUCCESS: 'FRAME_REQUEST_WORKFLOW_INITIALIZED_SUCCESS',
  FRAME_WORKSPACE_CANCELLED: 'FRAME_WORKSPACE_CANCELLED',
  FRAME_WORKSPACE_FORM_HEALTH_ERROR: 'FRAME_WORKSPACE_FORM_HEALTH_ERROR',
  FRAME_WORKSPACE_REQUESTED: 'FRAME_WORKSPACE_REQUESTED',
  FRAME_WORKSPACE_REQUESTED_ERROR: 'FRAME_WORKSPACE_REQUESTED_ERROR',
};

export default frameActions;
